import { useCurrentUser } from './useCurrentUser';
import { useToolPreferencesQuery } from './usePreferences';
import { useCrossTabEventsListener } from '@sironamedical/common/hooks/useCrossTabEventsListener';
import { NameSpaces, CrossWindowDataRefetchType } from 'modules/EventsManager';
import { WithApolloContext } from 'modules/Apollo/types';

/**
 * Enables cross-window synchronization of Viewer settings changes. Mounting this hook will
 * subscribe the window to inbound requests data refetch events.
 */
export const useViewerSettingsSync = ({
  onSyncRequest,
  context,
}: { onSyncRequest?: () => void } & WithApolloContext): void => {
  const { refetch: refetchCurrentUser } = useCurrentUser({ context });
  const { refetch: refetchToolPreferences } = useToolPreferencesQuery();

  useCrossTabEventsListener(NameSpaces.CROSS_WINDOW_DATA_REFETCH, async ({ source, payload }) => {
    if (source === 'remote' && payload.type === CrossWindowDataRefetchType.USER) {
      onSyncRequest?.();
      await refetchCurrentUser();
      await refetchToolPreferences();
    }
  });
};
